import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const Features = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  return (
    <section className="bg-slate-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {t.team.title}
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            {t.team.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {t.team.members.map((member, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-7 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-t-4 border-indigo-500"
            >
              <div className="text-5xl mb-5">{member.icon}</div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {member.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {member.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
